import { AuthUser } from '../../contexts/AuthProvider/types';
import { MedisanteOrgReport } from '../Dashboard/types';
import { MedisanteDevice } from '../Device/types';
import { decorateDeviceWithStatuses } from '../Devices/config';
import { StatusesKeys } from '../Devices/types';
import { initialKnownIssues } from './constants';
import { KnownIssues } from './types';

export const getKnownIssues = (
  devices: MedisanteDevice[],
  authUser: AuthUser
) => {
  const devicesWithStatuses = devices.map((d) => {
    return decorateDeviceWithStatuses(d, authUser);
  });
  return devicesWithStatuses.reduce((issues, device) => {
    if (device.statuses) {
      Object.entries(device.statuses).forEach(([key, value]) => {
        const statusKey = key as StatusesKeys;
        if (value) {
          const issue = issues[statusKey] || {
            ...initialKnownIssues[statusKey],
          };

          issue.deviceCount++;
          issues[statusKey] = issue;
        }
      });
    }
    return issues;
  }, {} as Partial<KnownIssues>);
};

export const getKnownIssuesByReports = (reports: MedisanteOrgReport[]) => {
  return reports.reduce((issues, report) => {
    let newIssues = { ...issues };
    if (report.syncScheduleCritical > 0) {
      const issue = issues.isBehindSyncingSchedule || {
        ...initialKnownIssues.isBehindSyncingSchedule,
      };
      issue.deviceCount += report.syncScheduleCritical;
      newIssues = { ...newIssues, isBehindSyncingSchedule: issue };
    }

    if (report.batteryWarning > 0) {
      const issue = issues.hasLowBattery || {
        ...initialKnownIssues.hasLowBattery,
      };
      issue.deviceCount += report.batteryWarning;
      newIssues = { ...newIssues, hasLowBattery: issue };
    }
    if (report.batteryAverageWarning > 0) {
      const issue = issues.hasAvgLowBattery || {
        ...initialKnownIssues.hasAvgLowBattery,
      };
      issue.deviceCount += report.batteryAverageWarning;
      newIssues = { ...newIssues, hasAvgLowBattery: issue };
    }

    if (report.batteryCritical > 0) {
      const issue = issues.hasMinBattery || {
        ...initialKnownIssues.hasMinBattery,
      };
      issue.deviceCount += report.batteryCritical;
      newIssues = { ...newIssues, hasMinBattery: issue };
    }
    if (report.batteryAverageCritical > 0) {
      const issue = issues.hasAvgMinBattery || {
        ...initialKnownIssues.hasAvgMinBattery,
      };
      issue.deviceCount += report.batteryAverageCritical;
      newIssues = { ...newIssues, hasAvgMinBattery: issue };
    }

    if (report.signalStrengthWarning > 0) {
      const issue = issues.hasLowSignalStrength || {
        ...initialKnownIssues.hasLowSignalStrength,
      };
      issue.deviceCount += report.signalStrengthWarning;
      newIssues = { ...newIssues, hasLowSignalStrength: issue };
    }
    if (report.signalStrengthAverageWarning > 0) {
      const issue = issues.hasAvgLowSignalStrength || {
        ...initialKnownIssues.hasAvgLowSignalStrength,
      };
      issue.deviceCount += report.signalStrengthAverageWarning;
      newIssues = { ...newIssues, hasAvgLowSignalStrength: issue };
    }

    if (report.signalStrengthCritical > 0) {
      const issue = issues.hasMinSignalStrength || {
        ...initialKnownIssues.hasMinSignalStrength,
      };
      issue.deviceCount += report.signalStrengthCritical;
      newIssues = { ...newIssues, hasMinSignalStrength: issue };
    }
    if (report.signalStrengthAverageCritical > 0) {
      const issue = issues.hasAvgMinSignalStrength || {
        ...initialKnownIssues.hasAvgMinSignalStrength,
      };
      issue.deviceCount += report.signalStrengthAverageCritical;
      newIssues = { ...newIssues, hasAvgMinSignalStrength: issue };
    }

    if (report.noTargetSystemSet > 0) {
      const issue = issues.hasNoTargetSystem || {
        ...initialKnownIssues.hasNoTargetSystem,
      };
      issue.deviceCount += report.noTargetSystemSet;
      newIssues = { ...newIssues, hasNoTargetSystem: issue };
    }

    if (report.hasPendingChanges > 0) {
      const issue = issues.hasPendingChanges || {
        ...initialKnownIssues.hasPendingChanges,
      };
      issue.deviceCount += report.hasPendingChanges;
      newIssues = { ...newIssues, hasPendingChanges: issue };
    }

    return newIssues;
  }, {} as Partial<KnownIssues>);
};
